export const advertismentCommand = {
  sendToPlatform: 'sendToPlatform',
};
